/**
 * TemplatePage - Alias for BluePrintsPage
 * 
 * This page renders templates using the same configuration as BluePrintsPage.
 * It exists for backward compatibility with the "templates" route.
 */
import BluePrintsPage from './BluePrintsPage';

export default function TemplatePage() {
  return <BluePrintsPage />;
}
